import { useState } from "react";
import { Box, Button, SheetContainer, Stack, Text } from "@bookingcom/bui-react";

type AddAirlineSuccessModalProps = {
  active: boolean;
  airlineCode: string;
  airlineName: string;
  onClose: () => void;
};

export const AddAirlineSuccessModal = ({ active, airlineCode, airlineName, onClose }: AddAirlineSuccessModalProps) => {
  const [copied, setCopied] = useState(false);

  const slackMessage = `Hi team, I've just onboarded a new airline: ${airlineName} (${airlineCode}). Could you please trigger the metrics backfill for this airline? Thank you!`;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(slackMessage);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <SheetContainer active={active} position="center" size={520} fill hideClose onCloseTrigger={onClose}>
      <Box mixin={{ padding: 8 }}>
        <Stack gap={4} alignItems="start">
          <Stack gap={2}>
            <Text variant="headline_2">Airline added successfully</Text>
            <Text variant="body_1" color="neutral_alt">
              {airlineName} ({airlineCode}) has been onboarded to the portal.
            </Text>
          </Stack>

          <Stack gap={2}>
            <Text variant="emphasized_2">
              Send this message to #flights-fde-sm-airline-performance-metrics:
            </Text>
            <Box
              mixin={{ padding: 4 }}
              borderRadius={100}
              attributes={{ style: { backgroundColor: "var(--bui_color_background_elevation_one)" } }}
            >
              <Text variant="body_2">{slackMessage}</Text>
            </Box>
            <Button variant="secondary" size="medium" onClick={handleCopy}>
              {copied ? "Copied!" : "Copy message"}
            </Button>
          </Stack>

          <Button size="large" onClick={onClose}>
            Done
          </Button>
        </Stack>
      </Box>
    </SheetContainer>
  );
};
